const axios = require('axios');

export const http_request= async ({endpoint,service,variables})=>{

try{

  const  {data}=await axios({
       url: `${endpoint}/${service}.php`,
       method: 'post',
   responseType: 'json',
      data: variables,
     })

   if(data.error){

      throw new Error(data.message)
   }

   return data

 }
 catch(e){

     throw new Error(e.message)
 }

}
